// **React Imports
import React, { memo } from 'react'

// **MUI Imports
import { Box, Typography } from '@mui/material'

// **Component Imports
import Icon from '../icon'

const RequiredLabelComponent = ({
  label = '',
  error = false,
  tooltipText = '',
  required = false,
  needBottomMargin = true,
  labelStyle = { fontSize: '0.8125rem' }
}) => {
  return (
    <Box
      sx={{
        gap: '2px',
        display: 'flex',
        alignItems: 'flex-end',
        marginBottom: needBottomMargin ? '4px' : 0,
        '*': { lineHeight: '1.154 !important' }
      }}
    >
      <Typography component="span" sx={{ ...labelStyle }}>
        {label}
        {required && (
          <Typography
            component="span"
            fontSize={'0.8125rem'}
            {...(error ? { color: 'error' } : {})}
          >
            *
          </Typography>
        )}
      </Typography>
      {tooltipText && (
        <Icon
          fontSize={'16px'}
          icon={'material-symbols:info-outline'}
          title={tooltipText}
          style={{ color: 'var(--text-secondary)', marginLeft: '2px' }}
        />
      )}
    </Box>
  )
}

export default memo(RequiredLabelComponent)
